export const CONVERT_GOAL_KEYS = {
  /**
   * For actions that may lead to a lead being generated, such as opening a modal to send a message,
   * requesting a dealer's phone number, opening the link to the seller's WhatsApp, and requesting to reserve a vehicle.
   */
  PRO_LEAD_INTENTION: 'pro-lead-intention',
  /**
   * For user actions that include contacting the dealer by phone, sending a message to a dealer, and
   * successfully reserving a vehicle.
   */
  PRO_LEAD_GENERATED: 'pro-lead-generated',

  /**
   * Same as PRO_LEAD_GENERATED but only tracked when the ad price is >= €20,000.
   */
  PRO_LEAD_GENERATED_OVER_20K: 'pro-lead-generated-over-20k',

  /**
   * For lead-generating user actions on a private (non-dealer) car ad — e.g. revealing the
   * seller's phone number then calling, or submitting the Send Message form.
   */
  PRIVATE_LEAD_GENERATED: 'private-leads-generated',
} as const;

export type ConvertGoalKeys =
  (typeof CONVERT_GOAL_KEYS)[keyof typeof CONVERT_GOAL_KEYS];
